import { ErrorBoundary, JSX } from "solid-js";

import Telemetry from "@repo/telemetry";

declare namespace HydrationFallback {
  type Props = {
    children: JSX.Element;
  };
}
export default HydrationFallback;
function HydrationFallback({ children }: D<HydrationFallback.Props>) {
  return (
    <ErrorBoundary
      fallback={(err) => {
        Telemetry.captureError(err);
        return children;
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
